import React from "react"
import { redirect } from "react-router-dom"
import isJwt from "validator/lib/isJWT"

import { PublicContainer } from "containers"
import { ErrorBoundary } from "components"

const Signin = React.lazy(() => import("../pages/signin"))
const PrintShift = React.lazy(() => import("../pages/print-shift"))
const PageNotFound = React.lazy(() => import("../pages/404"))
const ZarinpalPaymentResult = React.lazy(() => import("../pages/zarinpal-payment-result"))
const SocialIntegrations = React.lazy(() => import("../pages/social-integrations"))

const privateRoutes = {
  errorElement: <ErrorBoundary />,
  element: <PublicContainer />,
  children: [
    {
      index: true,
      path: "/",
      element: <Signin />
    },
    {
      index: true,
      path: "/zarinpal/payment/result",
      element: <ZarinpalPaymentResult />
    },
    {
      index: true,
      path: "/social-integrations",
      element: <SocialIntegrations />
    },
    {
      path: "*",
      element: <PageNotFound />
    },
    {
      loader: () => !isJwt(localStorage.at || "") ? redirect("/") : true,
      path: "/print-shift/:shiftId",
      element: <PrintShift />
    }
  ]
}

export default privateRoutes